import { render, staticRenderFns } from "./CourseTrained.vue?vue&type=template&id=dee967a6&scoped=true&"
import script from "./CourseTrained.vue?vue&type=script&lang=js&"
export * from "./CourseTrained.vue?vue&type=script&lang=js&"
import style0 from "./CourseTrained.vue?vue&type=style&index=0&id=dee967a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee967a6",
  null
  
)

export default component.exports